import React from 'react';

const ArtworkDetailsSkeleton = () => {
  return (
    <div className="flex flex-col justify-between p-6 text-left align-middle rounded-lg md:w-1">
      {/* Title Skeleton */}
      <div className="my-6">
        <div className="h-12 bg-gray-700 rounded-lg animate-pulse w-3/4 mb-2"></div>
        <div className="h-12 bg-gray-700 rounded-lg animate-pulse w-1/2"></div>
      </div>

      {/* Image Skeleton */}
      <div className="flex flex-col justify-between w-auto text-left rounded-lg shadow-lg bg-gray-700 animate-pulse">
        <div className="w-full h-96 rounded-lg"></div>
      </div>
    </div>
  );
};

export default ArtworkDetailsSkeleton;

